import { GenreColor } from "../assets/Constant/GenreColor"

export const GenreColorGenerator = genreName => {
    try{
        return GenreColor[genreName].color
    } catch {
        return '#aaa'
    }
}